export const EmailNotificationSettingOption = {
  WORK_QUEUE: 'work_queue',
  BNET_STATUS: 'bnet_status',
  BNET_PURCHASE_STATUS: 'bnet_purchase_status'
};

export const EMAIL_NOTIFICATION_SETTING_OPTIONS = Object.values(EmailNotificationSettingOption);

export default EmailNotificationSettingOption;
